import { create } from 'zustand/react'

import { getIconNameByType } from '../../../assets/icons'
import { FormActiveItem, FormBuilderConfig } from '../../../modules/shared/form-builder/types/form-builder.types'

type FormBuilderStore = {
  selectedItems: FormActiveItem[]
  activeItem: FormActiveItem | null
  setInitialSelectedItems: (initialSelectedItems: FormBuilderConfig[]) => void
  setSelectedItems: (selectedItems: FormActiveItem[]) => void
  setActiveItem: (activeItem: FormActiveItem | null) => void
  changeItemPositionUp: (itemSeq: number) => void
  changeItemPositionDown: (itemSeq: number) => void
  deleteSelectedItem: (itemSeq: number) => void
  clear: () => void
}

export const useFormBuilderStore = create<FormBuilderStore>(
  (set, get): FormBuilderStore => ({
    selectedItems: [],

    activeItem: null,

    setSelectedItems: (selectedItems: FormActiveItem[]) => {
      set({ selectedItems })
    },

    setActiveItem: (activeItem: FormActiveItem | null) => {
      set({ activeItem })
    },

    setInitialSelectedItems: (initialSelectedItems: FormBuilderConfig[]) => {
      const selectedItems = initialSelectedItems.map((item) => ({
        id: item.id,
        type: item.type,
        icon: getIconNameByType(item.type),
        title: item.label,
        seq: item.position,
        config: item,
      }))

      set({ selectedItems })
    },

    changeItemPositionUp: (itemSeq: number) => {
      const selectedItems = [...get().selectedItems]
      const [item] = selectedItems.splice(itemSeq, 1)
      selectedItems.splice(itemSeq - 1, 0, item)
      const readySelectedItems = selectedItems.map((item, i) => ({ ...item, seq: i }))
      set({ selectedItems: readySelectedItems, activeItem: null })
    },

    changeItemPositionDown: (itemSeq: number) => {
      const selectedItems = [...get().selectedItems]
      const [item] = selectedItems.splice(itemSeq, 1)
      selectedItems.splice(itemSeq + 1, 0, item)
      const readySelectedItems = selectedItems.map((item, i) => ({ ...item, seq: i }))
      set({ selectedItems: readySelectedItems, activeItem: null })
    },

    deleteSelectedItem: (itemSeq: number) => {
      const selectedItems = [...get().selectedItems]
      selectedItems.splice(itemSeq, 1)
      const readySelectedItems = selectedItems.map((item, i) => ({ ...item, seq: i }))
      set({ selectedItems: readySelectedItems, activeItem: null })
    },

    clear: () => {
      set({ selectedItems: [], activeItem: null })
    },
  }),
)
